export default defineNuxtPlugin((nuxtApp) => {
	if (import.meta.dev) {
		nuxtApp.vueApp.config.errorHandler = (err, _i, info) => {
			console.error("[Vue error]", info, err);
		};
	}
});
